import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "weChatContainer" }
const _hoisted_2 = { class: "weChatMenuArea" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "weChatMenuArea--avatar" }, " 头像区 ", -1)
const _hoisted_4 = { class: "weChatLeftContainer" }
const _hoisted_5 = { class: "weChatConvWindow--search-area" }
const _hoisted_6 = { class: "weChatConvListArea" }
const _hoisted_7 = { class: "weChatMsgArea" }

import WeChatMenu from "@/components/weChat/WeChatMenu.vue";
import WeChatConvWindow from "@/components/weChat/WeChatConvWindow.vue";
import WeChatMsgWindow from "@/components/weChat/WeChatMsgWindow.vue";
import WeChatContactWindow from "@/components/weChat/WeChatContactWindow.vue";
import WeChatContactMsgWindow from "@/components/weChat/WeChatContactMsgWindow.vue";
import WeChatSearch from '@/components/weChat/WeChatSearh.vue';
import WeChatSearchWindow from "./WeChatSearchWindow.vue";

// import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { computed, onMounted, onUnmounted } from "vue";
import { WeChatMutations, WeChatGetters, WeChatActions } from "@/store/modules/weChat";

// const route = useRoute();


import { defineComponent } from "vue";

const __default__ = defineComponent({
    name: "WeChatContainer"
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
// const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
// const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const selectMenu = computed(() => {
    return store.getters[`weChat/${WeChatGetters.getSelectMenu}`];
});

onUnmounted(() => {
    store.commit(`weChat/${WeChatMutations.resetAll}`);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(WeChatMenu)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(WeChatSearch)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(selectMenu) === '1')
          ? (_openBlock(), _createBlock(WeChatConvWindow, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(selectMenu) === '2')
          ? (_openBlock(), _createBlock(WeChatContactWindow, { key: 1 }))
          : _createCommentVNode("", true),
        (_unref(selectMenu) === '4')
          ? (_openBlock(), _createBlock(WeChatSearchWindow, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_unref(selectMenu) === '1' || _unref(selectMenu) == '4')
        ? (_openBlock(), _createBlock(WeChatMsgWindow, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(selectMenu) === '2')
        ? (_openBlock(), _createBlock(WeChatContactMsgWindow, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})